import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { TicketSize } from '../../types'
import ActionTypes from './actionTypes'

type FetchTicketSizesRequest = {
    type: typeof ActionTypes.TICKET_SIZES_FETCH_REQUEST;
    payload: never;
}

type FetchTicketSizesFailure = {
    type: typeof ActionTypes.TICKET_SIZES_FETCH_FAILURE;
    payload: Error;
}

type FetchTicketSizesSuccess = {
    type: typeof ActionTypes.TICKET_SIZES_FETCH_SUCCESS;
    payload: TicketSize[];
}

function fetchTicketSizes() {
    return createAction<RootState, TicketSize[], never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-sizes`,
        method: 'GET',
        types: [
            ActionTypes.TICKET_SIZES_FETCH_REQUEST,
            ActionTypes.TICKET_SIZES_FETCH_SUCCESS,
            ActionTypes.TICKET_SIZES_FETCH_FAILURE,
        ],
    })
}

export type FetchTicketSizesAction = FetchTicketSizesRequest
    | FetchTicketSizesFailure
    | FetchTicketSizesSuccess

export default fetchTicketSizes
